const routes = [
    {
        path: '/cap/news/list',
        component: function () {
            return import('@/components/admin/cap/NewsList')
        }
    },
    {
        path: '/cap/news/detail',
        component: function () {
            return import('@/components/admin/cap/NewsDetail')
        }
    },
    {
        path: '/cap/ad/manager',
        component: function () {
            return import('@/components/admin/cap/Ad')
        }
    },
    {
        path: '/cap/ad/list',
        component: function () {
            return import('@/components/admin/cap/AdList')
        }
    },
    {
        path: '/cap/ad/detail',
        component: function () {
            return import('@/components/admin/cap/AdDetail')
        }
    },
    {
        path: '/cap/category/list',
        component: function () {
            return import('@/components/admin/cap/NewsCategory')
        }
    },
    {
        path: '/cap/category/detail',
        component: function () {
            return import('@/components/admin/cap/NewsCategoryDetail')
        }
    },
    {
        path: '/cap/contact',
        component: function () {
            return import('@/components/admin/cap/ContactList')
        }
    },
]

export default routes